<template>
  <div class="show-life-style pt-2 pb-3">
    <div class="row">
      <div class="col-md-6 pl-0">
        <h6 class="is-bold text-evollu-gray-light mb-3">
          {{ title }}
        </h6>
      </div>

      <div class="col-md-6 text-right" v-if="value && value.updated_at !== null && value.updated_at !== undefined">
        <small>
          {{ $t('clinical.people.anamnesis.updated_at') }}
        </small>
        <small class="is-bold">
          {{$t('clinical.people.anamnesis.updated_by', {date: getExpressiveDate(value.updated_at), name: value.updated_by ? value.updated_by.name : ''})}}
        </small>
      </div>
    </div>

    <section v-if="value !== null && value !== undefined" class="px-2">

      <!-- Hearing Difficulty Relation -->
      <div class="answer-wrapper align-items-start">
        <label>
          {{$t('clinical.people.anamnesis.asks_for_repeat')}}
        </label>
        <span class="is-bold">
          {{getSingleOptionAnswer(formOptions.commonOptions, value.asks_to_repeat)}}
        </span>
      </div>

      <!-- Hearing Difficulty Environments -->
      <div class="answer-wrapper">
        <label>
          {{$t('clinical.people.anamnesis.hearing_difficulties_environments')}}
        </label>
        <span class="is-bold">
          {{getMultipleOptionAnswer(formOptions.hearingDifficultyEnvironments, value.hearing_difficulty_environment_ids)}}
        </span>
      </div>

      <!-- Hearing Difficulty Environments Obs -->
      <div class="answer-wrapper">
        <label>
          {{$t('clinical.people.anamnesis.hearing_difficulties_environments_obs')}}
        </label>
        <span class="is-bold">
          {{getTextAnswer(value.hearing_difficulty_environments_obs)}}
        </span>
      </div>

      <!-- Isolation Because of Hearing Loss -->
      <div class="answer-wrapper">
        <label>
          {{$t('clinical.people.anamnesis.isolation_because_of_hearing_loss')}}
        </label>
        <span class="is-bold">
          {{getSingleOptionAnswer(formOptions.commonOptions, value.isolation_because_of_hearing_loss)}}
        </span>
      </div>

      <!-- Shame Because of Hearing Loss -->
      <div class="answer-wrapper">
        <label>
          {{$t('clinical.people.anamnesis.shame_because_of_hearing_loss')}}
        </label>
        <span class="is-bold">
          {{getSingleOptionAnswer(formOptions.commonOptions, value.shame_because_of_hearing_loss)}}
        </span>
      </div>

      <!-- Nervous Because of Hearing Loss -->
      <div class="answer-wrapper">
        <label>
          {{$t('clinical.people.anamnesis.nervous_because_of_hearing_loss')}}
        </label>
        <span class="is-bold">
          {{getSingleOptionAnswer(formOptions.commonOptions, value.nervous_because_of_hearing_loss)}}
        </span>
      </div>

    </section>

    <section v-else class="px-2">
      <span>{{$t('clinical.people.no_data')}}</span>
    </section>
  </div>
</template>

<script>
import * as AnamnesisOptions from './AnamnesisOptions'
export default {
  props: {
    value: {
      type: Object,
      required: false
    },
    title: {
      type: String,
      required: false,
      default: function () {
        return this.$t('clinical.people.anamnesis.life_style')
      }
    }
  },
  data: function () {
    return {
      formOptions: AnamnesisOptions
    }
  },
  methods: {
    getExpressiveDate: function (value) {
      if (value) {
        if (this.$options.filters.isToday(value)) {
          return this.$t('date_helpers.today')
        } else {
          return this.$options.filters.localTime(value, `DD [${this.$t('date_helpers.day_of_month_separator')}] MMMM [${this.$t('date_helpers.day_of_month_separator')}] YYYY`, '', this.locale)
        }
      }
      return ''
    },
    getTextAnswer: function (answer, defaultValue = 'N/A') {
      return answer || defaultValue
    },
    getBooleanAnswer: function (answer, defaultValue = 'N/A') {
      return answer === null ? defaultValue : (answer === true ? this.$t('yes') : this.$t('no'))
    },
    getSingleOptionAnswer: function (options, answerId, defaultValue = 'N/A') {
      let option = null
      if (answerId !== null) {
        option = options.find(option => option.id === answerId)
        if (option) {
          option = this.$t(option.name)
        }
      }
      return option || defaultValue
    },
    getMultipleOptionAnswer: function (options, answerIds, defaultValue = 'N/A') {
      let answer = null
      if (Array.isArray(answerIds) && answerIds.length > 0) {
        answer = options.filter(option => answerIds.includes(option.id)).map(option => this.$t(option.name)).join(', ')
      }

      return answer || defaultValue
    }
  }
}
</script>
<style lang="scss">

@mixin for-desktop {
  @media (min-width: 766px) {
    @content;
  }
}

.answer-wrapper {
  display: flex;
  flex-direction: column;
  margin-bottom: 0.75rem;
  justify-content: flex-start;

  label {
    margin-bottom: 0rem;
  }

  @include for-desktop {
    flex-direction: row;
    align-items: center;

    label {
      max-width: 80%;
    }

    span {
      margin-left: 0.25rem;
    }
  }
}

</style>
